export const PRINCIPLES_EN = [
  { num: "01", title: "Authorisation and purpose", desc: "Authorisation and purpose defined before any data capture." },
  { num: "02", title: "Least privilege", desc: "Least privilege and compartmentalisation across all access and flows." },
  { num: "03", title: "Encryption", desc: "Encryption in transit and at rest where the scope requires it." },
  { num: "04", title: "Record integrity", desc: "Record integrity and verifiable time synchronisation." },
  { num: "05", title: "Version control", desc: "Version and change control over every deployed component." },
  { num: "06", title: "Traceability", desc: "Traceability of queries, decisions and exports." },
  { num: "07", title: "Segregation", desc: "Segregation between operations, administration, audit and evidence." },
  { num: "08", title: "Defined retention", desc: "Retention and deletion defined by scope, not by default." },
  { num: "09", title: "Human validation", desc: "Human validation of automated results before deciding." },
  { num: "10", title: "Incident response", desc: "Incident response and continuous review of controls." },
  { num: "11", title: "Privacy by design", desc: "Privacy by design across product, architecture and deployment." },
  { num: "12", title: "Chain of custody", desc: "Chain of custody whenever evidence must be preserved." },
];

export const GOVERNANCE_CLOSING_EN =
  "Integration is designed from identity, purpose and control. Not from the indiscriminate accumulation of data.";
